document.addEventListener("DOMContentLoaded", () => {
  // 同步所有列的行高
  function syncRowHeights() {
    const slides = document.querySelectorAll(".parameter-column");
    if (slides.length <= 1) return;

    const rowCount =
      slides[0]?.querySelectorAll(".parameter-value").length || 0;
    if (rowCount === 0) return;

    // 创建数组存储每行的最大高度
    const maxHeights = new Array(rowCount).fill(0);

    // 收集每行的最大高度
    slides.forEach((slide) => {
      const rows = slide.querySelectorAll(".parameter-value");
      rows.forEach((row, rowIndex) => {
        row.style.height = "auto";
        maxHeights[rowIndex] = Math.max(maxHeights[rowIndex], row.offsetHeight);
      });
    });

    // 设置所有行的高度
    slides.forEach((slide) => {
      const rows = slide.querySelectorAll(".parameter-value");
      rows.forEach((row, rowIndex) => {
        row.style.height = `${maxHeights[rowIndex]}px`;
      });
    });
  }

  syncRowHeights();

  var comparisonSwiper = new Swiper(".comparison-table", {
    slidesPerView: 6,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1500: {
          slidesPerView: 6,
        },
        1000: {
          slidesPerView: 5,
        },
        768: {
            slidesPerView: 4,
        },
        500: {
          slidesPerView: 3,
        },
        300: {
            slidesPerView: 2,
        }
      },
  });

});
